import styled from 'styled-components';

import { standardFocusStyles } from '@main/pc-core-components';
import { responsive, sp } from '@main/theme';

/**
 * has side menu tabs
 */
interface HideSideMenuProps {
  /** does the side menu have tabs */
  $showSideMenu: boolean;
}
/**
 * Logo main wrapper
 */
export const LogoWrapper = styled.div<HideSideMenuProps>`
  position: relative;
  background-color: ${({ theme, $showSideMenu }) =>
    $showSideMenu ? theme.colors.sidebarNavBg : theme.colors.white};
  height: 100%;
  display: flex;
  align-items: center;
  transition: background-color 0.2s ease-in-out;

  ${responsive.beforeTablet} {
    display: none;
  }

  ${responsive.atLeastTablet} {
    padding-left: ${sp(4.5)};
  }

  ${responsive.atLeastDesktop} {
    padding-left: ${sp(7)};
  }
`;

/**
 * Logo link wrapper
 */
export const LogoLink = styled.a`
  &:focus {
    .sidebar-org-logo {
      ${standardFocusStyles}
    }
  }
`;

/**
 * Logo image wrapper
 */
export const LogoImageWrapper = styled.img`
  position: absolute;
  top: 0;
  object-fit: contain;
  width: auto;
  max-width: ${sp(20)};
  height: 100%;
  transition: all 0.2s;
  padding: 12px 0;
  border-radius: ${sp(0.5)};

  &:hover {
    opacity: 0.8;
  }
`;

/**
 * Header wrapper
 */
export const HeaderWrapper = styled.div<HideSideMenuProps>`
  ${responsive.beforeTablet} {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }

  ${responsive.atLeastTablet} {
    transition: background-color 0.2s ease-in-out;
    background-color: ${({ theme, $showSideMenu }) =>
      $showSideMenu ? theme.colors.sidebarNavBg : theme.colors.white};
  }
`;

/**
 * Hero wrapper
 */
export const HeroWrapper = styled.header`
  background-color: ${({ theme }) => theme.colors.heroBg};

  ${responsive.beforeTablet} {
    padding-top: 80px;
  }
`;

/**
 * Row wrapper
 */
export const RowWrapper = styled.nav`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1000;

  /* ${responsive.justTablet} {
    position: relative;
    z-index: -2;
  } */
`;

/**
 * Wrapper for the Sidebar container to make it sticky
 */
export const ColWrapper = styled.div`
  ${responsive.atLeastTablet} {
    position: -webkit-sticky;
    position: sticky;
    /** Hardcoded off observation, affects SideMenuFadeTop */
    /** For sidebar column to stick under logo on long body content scroll */
    top: 84px;
    height: auto;
  }
`;

/**
 * Skip links wrapper
 */
export const SkipLinksWrapper = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;

  a {
    position: absolute;
    top: -3em;
    background-color: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
    padding: ${sp(0.5)} ${sp(1)};
  }

  a:focus {
    top: 0;
  }
`;
